import { render, staticRenderFns } from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=template&id=c106f3bc&scoped=true"
import script from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"
export * from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=script&lang=ts"
import style0 from "./TaksitSayisinaGoreTaksitlendirme.vue?vue&type=style&index=0&id=c106f3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c106f3bc",
  null
  
)

export default component.exports